import { useId } from "react";

const ShieldCheck = () => {
  const maskId = `shieldCheck${useId().replace(/:/g, "")}`;

  return (
    <svg width="48" height="48" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask id={maskId} maskUnits="userSpaceOnUse" x="10.457" y="6.96875" width="63" height="69" fill="black">
        <rect fill="white" x="10.457" y="6.96875" width="63" height="69" />
        <path d="M43.272 14.5582L63.9214 23.4079C65.3515 24.0208 66.2034 25.5061 66.0104 27.05L63.8703 44.1714C63.2115 49.442 60.575 54.2655 56.4945 57.6659L44.1318 67.9682C42.837 69.0472 40.9563 69.0472 39.6616 67.9682L27.2988 57.6659C23.2183 54.2655 20.5819 49.442 19.9231 44.1713L17.7829 27.05C17.5899 25.5061 18.4419 24.0208 19.872 23.4079L40.5214 14.5582C41.3996 14.1818 42.3938 14.1818 43.272 14.5582Z" />
      </mask>
      <path d="M63.9214 23.4079L43.272 14.5582C42.3938 14.1818 41.3996 14.1818 40.5214 14.5582L19.872 23.4079C18.4419 24.0208 17.5899 25.5061 17.7829 27.05L19.9231 44.1713C20.5819 49.442 23.2183 54.2655 27.2988 57.6659L39.6616 67.9682C40.9563 69.0472 42.837 69.0472 44.1318 67.9682L56.4945 57.6659C60.575 54.2655 63.2115 49.442 63.8703 44.1714L66.0104 27.05C66.2034 25.5061 65.3515 24.0208 63.9214 23.4079Z" strokeWidth="13.9655" strokeLinecap="round" stroke="#C78515" mask={`url(#${maskId})`} />
      <path d="M31.4224 41.896L40.3908 50.8644C41.1698 51.6434 42.4667 51.515 43.0777 50.5984L55.8621 31.4219" strokeWidth="6.98276" strokeLinecap="round" stroke="#C78515" />
    </svg>
  );
};

export default ShieldCheck;
